export enum REFUND_FLOW_STAGE {
  UPLOAD = 'upload',
  VIEWER = 'viewer',
  SCANNING = 'scanning',
  ITEMS = 'items',
  SUMMARY = 'summary',
}

export enum ANALYZE_INVOICE_STATUS {
  ITEMS_FOUND = 'items_found',
  NO_DATA = 'no_data',
}

export enum REFUND_FALLBACK_REASON {
  INVOICE_TOO_OLD = 'invoice_too_old',
  NO_FAST_REFUND_ITEMS = 'no_fast_refund_items',
  MULTIPLE_ITEMS = 'multiple_items',
}

/** Server BusinessErrorCode – per invoice item */
export enum BUSINESS_ERROR_CODE {
  NotRecognized = 0,
  NotEligible = 1,
  AlreadyUsed = 2,
  QuantityExceeded = 3,
}

export enum UPLOAD_VALIDATION_ERROR {
  INVALID_FORMAT = 'invalid_format',
  FILE_TOO_LARGE = 'file_too_large',
}

export const MEDICAL_EQUIPMENT_REFUND_SHIKUM_SUB_TYPE_ID = 416;

/**
 * Attachment field id for invoice / receipt.
 * Used because formMetaData for 416 may return no attachments.
 */
export const MEDICAL_EQUIPMENT_REFUND_INVOICE_FIELD_ID = '47';

/** Each request has a single invoice with one attached file. */
export const MAX_MEDICAL_EQUIPMENT_FILES = 1;

export const MAX_MEDICAL_EQUIPMENT_FILE_SIZE_IN_MB = 15;
export const MAX_MEDICAL_EQUIPMENT_FILE_SIZE_IN_BYTES =
  MAX_MEDICAL_EQUIPMENT_FILE_SIZE_IN_MB * 1024 * 1024;
